import React, { useEffect, useState } from "react";
import { GetPreApplicants } from "Services/OtherApis";
import Table from "./table";
import { useTranslation } from "react-i18next";

function PreApplicants() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  useEffect(() => {
    getPreApplicantsData("");
  }, []);

  async function getPreApplicantsData() {
    setLoading(true);
    try {
      const res = await GetPreApplicants(isRTL ? "ar" : "en");

      setData(res?.data || []); // Ensure data is always an array
    } catch (e) {
      console.error("Error fetching jobs:", e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="w-full">
      <Table
        loading={loading}
        data={data}
        isPreApplicants={true}
        isDropDown={false}
      />
    </div>
  );
}

export default PreApplicants;
